export const API_STATUS = {
  OPEN: 'open',
  CONNECTING: 'connecting',
  CLOSE: 'close',
};
